// Production team gate for Document Smart Text.
// Dev / preview / PR-preview deploys / test: feature is always on.
// Production (app.easil.com): only the pilot teams below get the feature.
// Remove this file (and the two consumer-import lines) once the feature
// is fully rolled out — see specs/2026-05-27-feature-document-smart-text-team-gate.md.
export const DOCUMENT_SMART_TEXT_ALLOWED_TEAM_IDS: ReadonlySet<string> =
  new Set([
    "c9e3e516-3546-4e6b-bcdb-a2f307fde368", // Brumbys
    "1463f1d0-4d8f-43e4-9444-0c088ddd7826", // Gloria Jeans
    "b0e41774-54f7-4188-8b38-0cc17ce36bc7", // Silk Lazer
    "7775c428-1715-4995-8a74-242f10da4602", // Moreland Hotel
    "e046c394-c7f3-4dd9-84e7-f43e131fbdac", // ALH Team
    "a4ced299-c58a-4d96-a303-95ce5f3fad77", // Worklocker
    "89b54e8d-fd0d-4efe-89a6-78d1ebccd921", // Safestyle
    "59019a4e-f3bc-4c96-b792-15311c89da8f", // Canopy Service Partners
    "4281c806-f627-4e1b-b0b1-b9a11739f0bf", // Canopy: American Arborists
    "d17ac3dd-046b-4e7d-9098-be32b48277d4", // Canopy: Arbor Equity
    "f4d0a6d1-8165-42ee-81cf-aa7254b81fa0", // Canopy: Beyond the Leaf
    "84706b3f-2d1c-4ccb-a0f4-b86b60639813", // Canopy: Birch Tree Care
    "9b3baa9f-f3d9-4053-ae9f-682e2d5d845d", // Canopy: Canopy Service Partners Marketing
    "ddcb6b36-86c4-4968-a7eb-10b7de5724e2", // Canopy: Emerald Tree & Shrub Care
    "6f2efb33-bdd5-4771-b36b-f4fed332fabe", // Canopy: Evergreen Tree Care
    "a1ef80da-c924-4e8a-b301-ac9be31fd79a", // Canopy: Gray's Tree Service
    "1784c477-21f0-4f2c-8207-8cdde7ea909f", // Canopy: Hubbard Tree Care
    "a3485049-9f5e-49a5-b861-58991967156c", // Canopy: Image Tree Pros
    "e8629fdf-aca4-4d04-9cd1-7b7d665af393", // Canopy: Image Tree Service
    "aaf2d361-b60c-4b9a-9101-d2daf0b813c8", // Canopy: Jeremiah's Tree Service
    "e51b73f4-cb8f-421e-874b-e2803e7bddde", // Canopy: Maguire Tree Care
    "9263cb0f-d193-48e1-85be-084f19dfb6ab", // Canopy: Marquis Tree Service
    "b990dc54-c07b-4006-a144-6f2d8bde7d11", // Canopy: Tree Pro
    "28b0c6a7-a954-4762-b829-87d27e871980", // Canopy: Tree Specialists
    "7211a7e2-4f86-450d-a74f-51aed373d56a", // Canopy: Truetimber Arborists
    "bea02d87-3963-41b3-998f-c9547bbbc0e5", // Canopy: Urban Tree Management
    "4775774b-c145-4ef8-b679-1f833ef64a43", // Canopy: West Coast Tree Care
    "59ee268f-ce7c-456b-9f6e-63011cc836ad" // Canopy: Willow Tree Service
  ]);

const PRODUCTION_HOSTNAME = "app.easil.com";

// Mirrors sessionRecorder.js#isProductionEnvironment so PR preview deploys
// (pr*-dev.easil.com), dev.easil.com, and the editor embedded in CopyMaker
// iframes are all treated as "not production" — the production build flag
// alone isn't enough, since PR previews are also production builds.
const getHostname = (): string => {
  if (typeof window === "undefined") return "";
  try {
    if (window.location !== window.parent.location) {
      return window.parent.location.hostname;
    }
  } catch {
    // Cross-origin parent throws SecurityError — fall through to own hostname.
  }
  return window.location.hostname;
};

const isProductionEnvironment = (): boolean =>
  process.env.NODE_ENV === "production" &&
  getHostname() === PRODUCTION_HOSTNAME;

export const isDocumentSmartTextAllowedForTeam = (
  teamId: string | null | undefined
): boolean => {
  if (!isProductionEnvironment()) return true;
  if (!teamId) return false;
  return DOCUMENT_SMART_TEXT_ALLOWED_TEAM_IDS.has(teamId);
};
